import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ChangeDetectorRef
} from '@angular/core';

@Component({
    selector: 'fcp-checkbox',
    templateUrl: './fcp-checkbox.component.html',
    styleUrls: ['./fcp-checkbox.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FcpCheckboxComponent {
    @ViewChild('label') labelElement: ElementRef<HTMLLabelElement>;
    @ViewChild('input') inputElement: ElementRef<HTMLInputElement>;

    @Input() id: string;
    @Input() e2eHook: string;
    @Input() checked = false;
    @Input() indeterminate = false;
    @Input() disabled = false;
    @Input() required = false;
    @Input() uncheckIndeterminate = false;

    @Output() readonly change: EventEmitter<boolean> = new EventEmitter<boolean>();

    public isUsingGivenValue = true;

    constructor(private cdr: ChangeDetectorRef) {}

    get inputId(): string {
        return this.id || 'inputId';
    }

    public onClick() {
        if (this.indeterminate && this.uncheckIndeterminate) {
            this.inputElement.nativeElement.indeterminate = false;
            this.inputElement.nativeElement.checked = false;
        }

        this.change.emit(this.inputElement.nativeElement.checked);
        this.cdr.markForCheck();
    }

    public onChange(event: Event) {
        this.isUsingGivenValue = false;

        // Avoid bubble up the change event from the input element
        event.stopPropagation();
        this.cdr.markForCheck();
    }
}
